import React from 'react'
import { ArrowLeftIcon } from '@mote/assets/icons'
import { preventBubblingEvent } from '@mote/helpers/browser'
import { KeyboardKey, __DEV__ } from '@mote/helpers/constants'
import styled, { css, th } from '@xstyled/styled-components'

export const BackButton = React.forwardRef(({ onClick, ...props }, ref) => {
  return (
    <Root
      ref={ref}
      size={32}
      aria-label='Go Back'
      onClick={event => {
        preventBubblingEvent(event)
        onClick?.(event)
      }}
      onKeyDown={event => {
        switch (event.keyCode) {
          case KeyboardKey.Space:
          case KeyboardKey.Enter:
            preventBubblingEvent(event)
            onClick?.(event)
            break
        }
      }}
      {...props}
    >
      <ArrowLeftIcon />
    </Root>
  )
})

const Root = styled.button`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: black;
  border-radius: 4px;
  border: 0;
  padding: 0;
  appearance: none;
  user-select: none;
  background-color: transparent;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  transition: all 150ms ease-in;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;

  &:hover,
  &:focus {
    background: ${th.color('grey.l4')};
  }

  &:focus {
    box-shadow: outline-primary;
  }

  ${({ size }) =>
    size !== undefined &&
    css`
      width: ${size}px;
      height: ${size}px;

      svg {
        height: ${size / 1.5}px;
        width: ${size / 1.5}px;
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
    `};
`

if (__DEV__) {
  BackButton.displayName = 'BackButton'
}
